<!--
 * @Author: your name
 * @Date: 2020-08-28 11:55:14
 * @LastEditTime: 2020-09-30 15:24:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_wap\src\components\subject.vue
-->
<template>
  <div class="imglist">
    <div :key="zhuanti.id">
      <router-link :to="{ path: '/goodsList', query: { id: zhuanti.clas_id, stype: 1 } }" class="mui-navigate-right">
        <div :class="zhuanti.is_image == 1 ? 'height0' : 'height'" class="title">
          <div class="title-left">
            <h3>{{ zhuanti.name }}</h3>
            <span class="subtitle">{{ zhuanti.subheading }}</span>
          </div>

          <div class="title-right">更多<van-icon name="arrow" color="rgba(38, 38, 38, 0.5)" /></div>
        </div>
      </router-link>

      <div>
        <router-link :to="{ path: '/goodsList', query: { id: zhuanti.clas_id, stype: 1 } }" class="direct-mail">
          <img :src="zhuanti.image == null ? '/static/errorimg1.png' : zhuanti.image" />
        </router-link>
        <div class="listGoods">
          <div v-for="(item, index) in zhuanti.item" :key="index" class="article">
            <router-link :to="{ path: '/goodslist/goods', query: { id: item.id } }">
              <div class="img-bg">
                <img :src="item.image == null ? '/static/errorimg1.png' : item.image"
                  onerror="src='/static/errorimg1.png'" />
              </div>
              <div class="product-detail">
                <span class="product-name" style="-webkit-box-orient: vertical">
                  <span class="tagbox">
                    <span class="tag xl" v-if="item.source == 4"> 一乡一物 </span>
                    <span class="tag xl" v-if="item.source == 3">卡券</span>
                    <span class="tag zc" v-if="item.source == 2">直充</span>
                    <span plain class="tag jd" v-if="item.source == 1">优选</span>
                    <span class="tag yx" v-if="item.source == 6">严选</span>
                  </span>

                  <span>{{ item.name }}</span>
                </span>
                <p class="product-price">
                  <span class="theme-col">{{ item.price_points }}</span>
                  <span class="ft12 theme-col">{{ $store.state.unitinfo.name }} </span>
                  <p class="product-price" v-if="item.price_cash">
                    <span class="theme-col">+{{ item.price_cash }}</span>
                    <span class="ft12">元</span>
                  </p>
                </p>

                <p class="product-price" v-if="stockShow && item.stock_status">
                  <span style="font-size: 12px; color: #9d9d9d">库存：{{ item.stock_number }}</span>
                </p>

                <p class="product-price" v-if="false">
                  <span style="font-size: 12px; text-decoration: line-through; color: #9d9d9d" v-if="
                    $store.state.webCount.market_status == 1 && item.market_price != undefined
                  ">市场价:{{ item.market_price }}元</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "imglist",
  props: {
    zhuanti: {}
  },
  data() {
    return {};
  },
  computed: {
    stockShow: function() {
      return this.$store.state.mallStockShow;
    }
  },
  methods: {
    getdatas() {}
  },
  created() {}
};
</script>
<style lang="less">
.imglist {
  width: calc(100% - 0.4rem);
  height: auto;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0rem 0.04rem 0.32rem 0rem #edeef6;
  border-radius: 0.16rem;
  overflow: hidden;

  .title {
    width: 100%;
    height: 0.9rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-left {
      display: flex;
      align-items: flex-end;

      h3 {
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #262626;
        line-height: 0.44rem;
      }

      .subtitle {
        font-size: 0.24rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.32rem;
        margin-left: 0.16rem;
      }
    }

    .title-right {
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      font-weight: 400;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.42rem;
    }
  }

  .direct-mail {
    display: inline-block;
    width: calc(100% - 0.4rem);
    height: 1.96rem;
    margin-left: 0.2rem;
    margin-top: 0.08rem;
    border-radius: 0.16rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .listGoods {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.2rem;
    margin-top: 0.24rem;
    display: flex;
    padding-bottom: 0.2rem;
    overflow-x: scroll;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      height: 0 !important;
      width: 0 !important;
    }

    .article {
      width: 1.92rem;
      min-height: 3.4rem;
      padding-right: 0.44rem;
      display: flex;
      justify-content: center;

      // 隐藏滚动条
      &::-webkit-scrollbar {
        height: 0 !important;
        width: 0 !important;
      }

      .img-bg {
        width: 100%;
        height: auto;

        img {
          width: 1.92rem;
          height: 1.92rem;
          border-radius: 0.12rem;
        }
      }

      .product-detail {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;

        .product-name {
          // height: 0.71rem;
          height: 0.725rem;
          font-size: 0.26rem;
          font-weight: bold;
          color: #262626;
          line-height: 0.36rem;
          margin-top: 0.2rem;
          // margin-bottom: 0.08rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          display: -moz-box;
          display: box;
          -webkit-line-clamp: 2; //共显示几行，再多就是省略号
          -moz-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          -moz-box-orient: vertical;
          box-orient: vertical;
        }

        .product-price {
          padding-top: 0.08rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #fe5c42;
          line-height: 0.4rem;
          display: flex;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subject2.vue